import { useCallback, useEffect, useState } from 'react';

const useStyles = ({ parentWidth, zIndex }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    width: `calc(${parentWidth}px / 2)`,
    marginLeft: `calc((${parentWidth}px - (${parentWidth}px / 2)) / 2)`,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    float: 'top',
    zIndex: zIndex || 1,
    color: 'red',
    marginTop: '10px',
    textShadow: '1px 1px #fff, 1px -1px #fff, -1px -1px #fff, -1px 1px #fff',
    pointerEvents: 'none',
  },
  title: {
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
});

const InDevelopmentBanner = ({ parentRef, zIndex }) => {
  const [parentWidth, setParentWidth] = useState(100);

  const handleWindowResize = useCallback(() => {
    setParentWidth(parentRef.current.offsetWidth);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => removeEventListener('resize', handleWindowResize);
  }, []);

  const styles = useStyles({ parentWidth, zIndex });

  return (
    <div style={styles.container}>
      <span style={styles.title}>PRELIMINARY DATA</span>
    </div>
  );
};

export default InDevelopmentBanner;
